import { ListItem, ListItemButton, ListItemText} from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'

import { useDefaultComponentTools } from '../../../hooks/useDefaultComponentTools'
import { setAssetSingle, setSelectedAsset } from '../../../store/redusers/assets/actions'

function AssetsSearchList({searchAssets, setIsSearchList}) {
	const { dispatch, theme } = useDefaultComponentTools(true)
	const handleClose = (asset) => {
		dispatch(setAssetSingle(asset))
		dispatch(setSelectedAsset({
			'assetSoId': asset.assetSoId,
			'assetType': asset.assetType},
		asset.assetName,
		'type_asset'
		))
		setIsSearchList(false)
	}
	return (
		<Box
			sx={{maxHeight: 500, overflow: 'auto',
				position: 'absolute', zIndex: 100 }}
		>
			{searchAssets.length ?
				searchAssets.map((item, index) => {
					return <ListItem
						sx={{background: theme.palette.second}}
						key={index} component='div' disablePadding
					>
						<ListItemButton onClick={() => handleClose(item)}>
							<ListItemText primary={item.assetName} />
						</ListItemButton>
					</ListItem>
				}) : null
			}
		</Box>
	)
}

AssetsSearchList.propTypes = {
	searchAssets: PropTypes.array,
	setIsSearchList: PropTypes.func
}

export default AssetsSearchList
